<template>
  <section class="forum-next-pending-queue" aria-labelledby="forum-next-pending-title">
    <header class="forum-next-section-heading"><h2 id="forum-next-pending-title">Pendientes de respuesta</h2><p>Abre el mensaje para revisar el contexto, responder o marcarlo como atendido.</p></header>
    <nav class="forum-next-activity-tabs" aria-label="Tipo de mensaje pendiente">
      <ForumNavLink v-for="filter in filters" :key="filter.value" :to="{ name: 'ForumNextPending', query: { type: filter.value } }" :selected="($route.query.type || 'all') === filter.value">{{ filter.label }}</ForumNavLink>
    </nav>
    <p class="forum-next-meta">{{ number(model.page.total) }} {{ model.page.total === 1 ? 'mensaje pendiente' : 'mensajes pendientes' }} · Publicaciones más recientes primero</p>
    <ul v-if="model.items.length" class="forum-next-hits"><li v-for="item in model.items" :key="item.type + ':' + item.id">
      <h3><router-link :to="link(item)">{{ item.title }}</router-link></h3>
      <p class="forum-next-meta">{{ item.type === 'comment' ? 'Respuesta' : 'Mensaje inicial' }} · {{ item.author.name }} · <ForumDate :value="item.createdAt" /></p>
      <p v-if="item.section" class="forum-next-meta">{{ item.section.title }}</p>
      <router-link class="forum-next-button" :to="link(item)">Abrir mensaje</router-link>
    </li></ul>
    <div v-else class="forum-next-status" role="status"><h3>No hay mensajes pendientes</h3><p>No hay resultados para este filtro.</p></div>
    <ForumPagination :page="model.page" />
  </section>
</template>
<script>
import ForumNavLink from './ForumNavLink.vue';
import ForumDate from './ForumDate.vue';
import ForumPagination from './ForumPagination.vue';
import { postLink } from '../models/forumNavigation';
export default {
  name: 'ForumPendingQueue', components: { ForumNavLink, ForumDate, ForumPagination }, props: { model: { type: Object, required: true } },
  data: () => ({ filters: [{ value: 'all', label: 'Todos' }, { value: 'topic', label: 'Hilos' }, { value: 'comment', label: 'Respuestas' }] }),
  methods: { link(item) { return postLink(item.threadId, item); }, number(value) { return new Intl.NumberFormat('es-ES').format(value); } }
};
</script>
